import React from 'react';
import { bonuses } from '../data/constants';
export function Bonuses() {
  return <section className="py-20 px-4 bg-surface2 border-y border-zinc-800" data-id="element-22">
      <div className="max-w-5xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-25">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-26">
            SIEMPRE INCLUIDOS — Sin costo adicional
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-27">
          {bonuses.map(b => <div key={b.id} className="bg-surface border border-zinc-700/50 p-6 rounded-xl flex gap-4" data-id="element-28">
              <div className="text-3xl" data-id="element-29">{b.icon}</div>
              <div data-id="element-30">
                <div className="text-xs font-bold text-primary mb-1" data-id="element-31">
                  BONO {b.id}
                </div>
                <h3 className="font-bold text-lg mb-2 leading-tight" data-id="element-32">
                  {b.name}
                </h3>
                <p className="text-zinc-400 text-sm mb-3" data-id="element-33">{b.desc}</p>
                <div className="text-sm font-bold" data-id="element-34">
                  <span className="line-through text-zinc-600 mr-2" data-id="element-35">
                    {b.value}
                  </span>
                  <span className="text-primary" data-id="element-36">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-primary/10 border border-primary/20 rounded-xl p-6 max-w-2xl mx-auto" data-id="element-37">
          <p className="text-lg md:text-xl font-bold" data-id="element-38">
            Valor total bonos:{' '}
            <span className="line-through text-zinc-500" data-id="element-39">$53.000</span> →{' '}
            <span className="text-primary" data-id="element-40">GRATIS con tu Combo Completo</span>
          </p>
        </div>
      </div>
    </section>;
}